import axios from 'axios'
import security from '@/services/security.js'

export default {
  getWffCollectionsReport (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey + '/wff-collections', config)
      .then(response => {
        return response.data
      })
  },
  getStaffRosterReport (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey + '/staff-roster', config)
      .then(response => {
        return response.data
      })
  },
  getParticipantRosterReport (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey + '/participant-roster', config)
      .then(response => {
        return response.data
      })
  },
  getApplicationForRecognitionReport (courseKey, scouterKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey + '/application-for-recognition/' + scouterKey, config)
      .then(response => {
        return response.data
      })
  },
  getFinalTicketReport (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey + '/final-ticket', config)
      .then(response => {
        return response.data
      })
  },
  getParticipantsByPositionReport (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey + '/participants-by-position', config)
      .then(response => {
        return response.data
      })
  },
  getPreCourseSignupReport (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey + '/precourse-signup', config)
      .then(response => {
        return response.data
      })
  },
  getFinanceReport (courseKey, budgetSummary, budgetDetails, reimbursementSummary, reimbursementDetails, receipts) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey + '/finance/' + budgetSummary + '/' +
                        budgetDetails + '/' + reimbursementSummary + '/' + reimbursementDetails + '/' +
                        receipts, config)
      .then(response => {
        return response.data
      })
  },
  getReportDashboard (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  getCloseoutCoversheet (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey + '/closeout', config)
      .then(response => {
        return response.data
      })
  },
  getHeader (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/reports/' + courseKey + '/header', config)
      .then(response => {
        return response.data
      })
  }
}
